import { gql } from '@apollo/client'

const DELETE_INSURANCE_POLICY = gql`
  mutation DELETE_INSURANCE_POLICY($insurancePolicy: ID!) {
    deleteInsurancePolicy(insurancePolicy: $insurancePolicy) {
      id
    }
  }
`

export default DELETE_INSURANCE_POLICY
